import { useState } from 'react';
import styled from 'styled-components';
import { Switch } from '@/ui';
import { usePreferences, useMoreLinks } from '@/hooks';

const Panel = styled.section`
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.color.glassBg};
  padding: 14px;
  margin-bottom: 16px;
`;
const Heading = styled.h2`
  margin: 0 0 12px;
  font-family: ${({ theme }) => theme.font.display};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-weight: 600;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.color.textPrimary};
`;
const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  @media (max-width: 720px) { grid-template-columns: 1fr; }
`;
const Item = styled.div` display: flex; justify-content: space-between; align-items: center; gap: 12px; `;
const Text = styled.div` min-width: 0; `;
const Label = styled.div` color: ${({ theme }) => theme.color.textPrimary}; font-size: ${({ theme }) => theme.fontSize.sm}; font-weight: 600; `;
const Sub = styled.div` color: ${({ theme }) => theme.color.textMuted}; font-size: ${({ theme }) => theme.fontSize.xs}; `;

export function QuickSettings() {
  const { quickToggles } = useMoreLinks();
  const { prefs, setPreference } = usePreferences();
  // Decorative toggles (autoplay/data-saver) keep ephemeral local state, keyed by id.
  const [decorative, setDecorative] = useState<Record<string, boolean>>({});

  return (
    <Panel>
      <Heading>Quick settings</Heading>
      <Row>
        {quickToggles.map((t) => {
          // The sole functional quick-toggle maps to the `reduceMotion` preference
          // (read/written app-wide). All others are decorative ephemeral local state.
          const functional = t.functional === true;
          const checked = functional ? prefs.reduceMotion : !!decorative[t.id];
          const onChange = (next: boolean) => {
            if (functional) void setPreference('reduceMotion', next);
            else setDecorative((d) => ({ ...d, [t.id]: next }));
          };
          return (
            <Item key={t.id}>
              <Text><Label>{t.label}</Label><Sub>{t.sub}</Sub></Text>
              <Switch checked={checked} onChange={onChange} label={t.label} />
            </Item>
          );
        })}
      </Row>
    </Panel>
  );
}
